export default __webpack_public_path__ + "static/banner-saving-for-a-holiday-b5d3ff1d8c2f4fc51d396b81509cb99a.jpg";